import React, { useState } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import TextFieldInput from "../../../../components/Input/text-field-input"
import CodeViewer from "../../../../components/CodeViewer/code-viewer"

const TextFieldInputPage = () => {
    const [value, setValue] = useState("")

    const codeBasicUsage = `import TextFieldInput from "src/v2/components/TextFieldInput/TextFieldInput"

const [value, setValue] = useState("")

<TextFieldInput
  label="Nome completo"
  placeholder="Digite o nome"
  value={value}
  onChange={(event) => setValue(event.target.value)}
/>`

    const codeStates = `<>
  <TextFieldInput
    label="Padrão"
    placeholder="Digite algo"
  />

  <TextFieldInput
    label="Com ajuda"
    placeholder="Digite o e-mail"
    helperText="Usaremos este e-mail para contato."
  />

  <TextFieldInput
    label="Erro"
    placeholder="Digite o CPF"
    error
    helperText="CPF inválido."
  />

  <TextFieldInput
    label="Desabilitado"
    placeholder="Campo desabilitado"
    disabled
  />
</>`

    const codePropsType = `type TextFieldInputProps = {
  label?: string
  placeholder?: string
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  helperText?: string
  error?: boolean
  disabled?: boolean
  fullWidth?: boolean
  type?: string           // ex: "text", "password", "email", "number"
  // ...props extras são repassadas para o TextField base (size, variant, etc.)
}`

    return (

            <Box>
                <Stack spacing={3}>

                    {/* INTRO + EXEMPLO PRINCIPAL */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`TextFieldInput`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {`O componente TextFieldInput encapsula o TextField do MUI com estilos padronizados e comportamento consistente em toda a aplicação. Ele é utilizado para entradas de texto simples, como formulários e filtros.`}
                            </Typography>

                            <Box mt={3}>
                                <Typography variant="h6" gutterBottom color="common.white">
                                    {`Exemplo principal`}
                                </Typography>

                                <Typography variant="body2" color="text.secondary" paragraph>
                                    {`Campo de texto controlado, com label e placeholder, ideal para formulários gerais.`}
                                </Typography>

                                <Box mt={2} sx={{ maxWidth: 400 }}>
                                    <TextFieldInput
                                        label="Nome completo"
                                        placeholder="Digite o nome"
                                        value={value}
                                        onChange={(event) => setValue(event.target.value)}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Paper>

                    {/* ESTADOS COMUNS */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Estados comuns`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Abaixo alguns estados comuns do TextFieldInput, como padrão, com texto de ajuda, erro e desabilitado.`}
                            </Typography>

                            <Box sx={{ display: "grid", gap: 2, maxWidth: 600 }}>
                                <TextFieldInput
                                    label="Padrão"
                                    placeholder="Digite algo"
                                    fullWidth
                                />

                                <TextFieldInput
                                    label="Com ajuda"
                                    placeholder="Digite o e-mail"
                                    helperText="Usaremos este e-mail para contato."
                                    fullWidth
                                />

                                <TextFieldInput
                                    label="Erro"
                                    placeholder="Digite o CPF"
                                    error
                                    helperText="CPF inválido."
                                    fullWidth
                                />

                                <TextFieldInput
                                    label="Desabilitado"
                                    placeholder="Campo desabilitado"
                                    disabled
                                    fullWidth
                                />
                            </Box>

                            <Box mt={3}>
                                <Paper variant="outlined">
                                    <Box p={2}>
                                        <Typography variant="subtitle2" gutterBottom color="common.white">
                                            {`Código de exemplo`}
                                        </Typography>
                                        <CodeViewer code={codeStates} language="jsx" />
                                    </Box>
                                </Paper>
                            </Box>
                        </Box>
                    </Paper>

                    {/* USO BÁSICO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Uso básico`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Exemplo mínimo de uso do TextFieldInput como campo controlado em um formulário.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeBasicUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* PROPRIEDADES DO COMPONENTE */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades do componente`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Principais propriedades expostas pelo TextFieldInput. Propriedades adicionais são repassadas diretamente para o TextField base do MUI via spread.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <Typography variant="subtitle2" gutterBottom color="common.white">
                                        {`Tipo das props (exemplo em TypeScript`}
                                        {`)`}
                                    </Typography>
                                    <CodeViewer code={codePropsType} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
    )
}

export default TextFieldInputPage